////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
///////COMPONENTS///////
import TableNested from '../../../components/Table/components/TableNested'
import ValueCheck from '../../../helpers/ValueCheck'

//////STYLED//////
const ScheduledPricesManagerNestedWrapper = styled.td`
	display: ${(props) => (props.isVisible ? 'table-cell' : 'none')};
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
	& > div {
		max-width: calc(100vw - 350px);
		position: sticky;
		left: 100px;
		min-width: max-content;
	}
	& > div:before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -1px;
		box-shadow: 3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div:after {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		right: -1px;
		box-shadow: -3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div > div {
		min-width: max-content;
	}
`
/////////STYLED/////////

const ScheduledPricesManagerNested = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: '',
		isInNestedTable: true,
	}

	const currency = props.row.currency.symbol

	const columns = [
		{
			dataHook: 'kioskCode',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_kioskCode'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'store',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_store'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'itemFamily.translationKey',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_family'],
			sortable: true,
			isAuthorize: true,
			toTranslate: true,
		},
		{
			dataHook: 'itemBrand.label',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_brand'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'label',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_product'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'standardPrice',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_itemPrice'],
			sortable: true,
			isAuthorize: true,
			component: (props) => ValueCheck.ValueCheck(props.row.standardPrice, currency),
		},
		{
			dataHook: 'standardPriceVATRate',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_itemVAT'],
			sortable: true,
			isAuthorize: true,
			component: (props) => ValueCheck.ValueCheck(props.row.standardPriceVATRate, '-', '%'),
		},
		{
			dataHook: 'depositPrice',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_depositPrice'],
			sortable: true,
			isAuthorize: true,
			component: (props) => ValueCheck.ValueCheck(props.row.depositPrice, '-', currency),
		},
		{
			dataHook: 'depositPriceVATRate',
			headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_depositVAT'],
			sortable: true,
			isAuthorize: true,
			component: (props) => ValueCheck.ValueCheck(props.row.depositPriceVATRate, '-', '%'),
		},
	]

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ScheduledPricesManagerNestedWrapper colSpan={props.colspan} isVisible={props.stateToggleNested}>
			<div>
				<div>{<TableNested inputColumns={columns} inputData={props.row.priceCampaignLines} inputConfig={config} />}</div>
			</div>
		</ScheduledPricesManagerNestedWrapper>
	)
}

ScheduledPricesManagerNested.propTypes = {}

ScheduledPricesManagerNested.defaultPropTypes = {}

export default ScheduledPricesManagerNested
